import React, { ReactElement } from 'react';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { Thematique } from '../../../../../common/src/entities';
import { ChampsThematique } from './DetailsThematique';

export interface PropsChampThematique {
    ordreAffichage: number;
}

export default function CreerThematique(
    props: Partial<PropsDeCreationEntite<Thematique>>,
    propsAffichage: PropsChampThematique,
): ReactElement {
    return (
        <FormulaireCreationEntite
            texteEntete={(t: Thematique) =>
                t.id ? (
                    <>
                        <small className="text-muted">Modification de la thématique</small>&nbsp;{t.name}
                    </>
                ) : (
                    <small className="text-muted">Création d&apos;une nouvelle thématique</small>
                )
            }
            entite={Thematique}
            noSave
            {...props}
        >
            <ChampsThematique ordreAffichage={propsAffichage.ordreAffichage} />
        </FormulaireCreationEntite>
    );
}
